import React from 'react';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import './timesheetPage.module.scss';
import { OverlayPage } from '../../../commonv3/components/molecules/layout/OverlayPage';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { V3Routes } from '../../routes';
import { TimesheetPositionListPane } from './TimesheetPositionListPane';
import { observer, Provider } from 'mobx-react';
import { observable, makeObservable } from 'mobx';
import { TimesheetPageState } from './states/TimesheetPageState';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { TimesheetInputCompletePane } from './TimesheetInputCompletePane';
import { TimesheetInputErrorPane } from './TimesheetInputErrorPane';
import { PageSection } from '../../components/atoms/layout/PageSection';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { groupByDate } from '../../../commonv3/types/reservable';
import { DateGroup } from '../../components/molecules/reservable/DateGroup';
import { ScheduleListItem } from '../../components/molecules/reservable/ScheduleListItem';
import { Confirmation } from '../../components/molecules/modals/Confirmation';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

type Props = RouteComponentProps;

export const TimesheetPage = withNavigation(NavigationSpecs.side())(
  observer(
    class TimesheetPage extends React.Component<Props> {
      pageState = new TimesheetPageState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      componentDidMount(): void {
        this.pageState.init();
      }

      render() {
        const { location } = this.props;
        const { reservedPositions, cancellationDialog, submitCancellation, submitState } = this.pageState;
        const groups = groupByDate(reservedPositions.getOrElse([]), (r) => r.session.starts_at);
        const breadCrumbItems = [{ text: 'シフト' }];
        return (
          <Page>
            <BreadCrumb items={breadCrumbItems} hasHome />
            <PageHeader title="Shift Management" testId="page-header-of-timesheet" />
            <PageBody styleName="body">
              <PageSection title="TIME SHEET" subTitle="直近のシフト" background="gray">
                {reservedPositions.loading && <LoaderRow />}
                {groups.map((group) => {
                  return (
                    <DateGroup key={group.date} date={group.date}>
                      {group.entries.map((entry) => (
                        <ScheduleListItem
                          key={entry.id}
                          title={entry.session.template_name}
                          reservable={entry.session}
                        />
                      ))}
                    </DateGroup>
                  );
                })}
              </PageSection>
              <Confirmation
                headerMessage="シフトのキャンセル"
                message="このシフトをキャンセルします。本当によろしいですか？"
                confirmationText={'キャンセルする'}
                loading={submitState.submitting}
                open={cancellationDialog.isOpen}
                onAbort={cancellationDialog.close}
                onConfirmation={submitCancellation}
              />
              <Provider pageState={this.pageState}>
                <OverlayPage
                  open={[
                    V3Routes.timesheetPositions().pathname,
                    V3Routes.timesheetComplete().pathname,
                    V3Routes.timesheetError().pathname,
                  ].includes(location.pathname)}
                  onRequestClose={() => GlobalStatesV3.routing.push(V3Routes.timesheetHome())}
                >
                  <Switch>
                    <Route path={V3Routes.timesheetPositions().pathname} component={TimesheetPositionListPane} />
                    <Route path={V3Routes.timesheetComplete().pathname} component={TimesheetInputCompletePane} />
                    <Route path={V3Routes.timesheetError().pathname} component={TimesheetInputErrorPane} />
                  </Switch>
                </OverlayPage>
              </Provider>
            </PageBody>
          </Page>
        );
      }
    }
  )
);
